// extracted by mini-css-extract-plugin
export var avatar = "_rx-3";
export var avatarContainer = "_rx-2";
export var avatarSpacer = "_rx-5";
export var avatarSpacerContainer = "_rx-4";
export var avatarStackContainer = "_rx-1";
export var bubble = "_rx-0";
export var remainderBubble = "_rx-6";